import { render, staticRenderFns } from "./SKBagi.vue?vue&type=template&id=6be90211&scoped=true&"
import script from "./SKBagi.vue?vue&type=script&lang=js&"
export * from "./SKBagi.vue?vue&type=script&lang=js&"
import style0 from "./SKBagi.vue?vue&type=style&index=0&id=6be90211&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6be90211",
  null
  
)

export default component.exports